export const GOOGLE_CLICK_ID_NAME = 'gclid';
export const GOOGLE_CLICK_DATE = 'gclidDate';
export const GOOGLE_CLICK_ID_REGEX = new RegExp(`(?:${GOOGLE_CLICK_ID_NAME}=)([a-zA-Z0-9_\\-]+)`);
export const GOOGLE_CLICK_ID_DATE_REGEX = new RegExp(`(?:^|; )${GOOGLE_CLICK_DATE}=([^;]*)`);
export const FACEBOOK_CLICK_ID_URL_PARAM = 'fbclid';
export const FACEBOOK_CLICK_ID_NAME = 'fbClickId';
export const FACEBOOK_CLICK_ID_REGEX = new RegExp(`(?:${FACEBOOK_CLICK_ID_NAME}=)([a-zA-Z0-9_\\-]+)`);

export const PARAMS_EXPIRY_DAYS = 180;

export const REFERRER_DOMAIN_MAP: Record<string, string> = {
  'l.facebook.com': 'facebook.com',
  'lm.facebook.com': 'facebook.com',
  'm.facebook.com': 'facebook.com',
};

export const UTM_URL_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

export const TRACKING_QUERY_PARAMS = ['landing_url'];

export const URL_TRACKING_PARAMS = [...UTM_URL_PARAMS, ...TRACKING_QUERY_PARAMS];

export const TRACKING_CONTEXT_PARAMS = ['landing_url', 'referrer', 'device'];

export const UTM_TRACKING_PARAMS = [...UTM_URL_PARAMS, ...TRACKING_CONTEXT_PARAMS];
